import React, {Component} from 'react';
import { CircleQuestionMark } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";
import * as Api from 'utils/api/api';
import * as reduxSelectors from '../store/application.reducers';
import {connect} from 'react-redux';
import _ from "lodash";
import {getAllUsers, setStepAction, setStepExceptions} from "./workflowdetails.action";
import translate from '../translations/translations.wrapper.jsx';
import UserSearch from '../input/UserSearch.component';
import Exceptions from "./ExceptionsWorkflows.component";
import {DOCUMENT_TYPE, RULE_TYPES} from 'utils/constants';
import {launchDarkly} from "utils/launchDarkly";
import { DropdownSelect } from "components/common/dropdown/DropdownSelect.component";
import { DropdownSelectTypes } from "types/gaiaComponents/dropdownButton.types";
import { Tooltip } from "components/tooltip/Tooltip";

export const FindByEmployeeRole = (props) => {
    const employeeRoleId = props.action && props.action.employeeRole;
    const mapRoleToName = employeeRoleId ? _.find(props.orgChartRoles, (roles => {
        return roles.orgChartRoleId === employeeRoleId
    })) : null;

    const displayValue = mapRoleToName ? mapRoleToName.name : props.translate("workflowDetails.selectRole");

    const selectEmployeeRole = function (value) {
        let rule = props.action ? _.clone(props.action) : RULE_TYPES[props.componentType];

        rule.employeeRole = value.orgChartRoleId;

        props.setStepAction(props.idStep, props.idRule, rule, props.stepNumber, props.ruleNumber);
    };

    const menuItems = props.orgChartRoles.map((rule) => {
        return {
            key: rule.orgChartRoleId,
            text: rule.name,
            onClick: () => selectEmployeeRole(rule),
            disabled: false,
            selected: employeeRoleId === rule.orgChartRoleId
        };
    });

    return (
        <div className="dropdown-menu-scrollable">
            <DropdownSelect
                id="Employee_Role_Selection"
                type={DropdownSelectTypes.VALUE}
                value={displayValue}
                items={menuItems}
                isEmpty={menuItems.length === 0}
            />
        </div>
    )
};
const FindByEmployeeStateToProps = function (store) {
    return {
        orgChartRoles: reduxSelectors.getOrganizationChart(store)
    };
};
export const FindByEmployeeRoleAction = connect(FindByEmployeeStateToProps, {setStepAction})(FindByEmployeeRole);


export const OrganisationChart = (props) => {

    let mapRoleToName = props.action && props.action.orgChartRole ? _.find(props.orgChartRoles, (roles => {
        return roles.orgChartRoleId === props.action.orgChartRole
    })) : null;

    let displayValue = mapRoleToName ? mapRoleToName.name : props.translate("workflowDetails.selectRole");

    let selectOrgChartRole = function (value) {
        let rule = props.action ? _.clone(props.action) : RULE_TYPES[props.componentType];
        rule.orgChartRole = value.orgChartRoleId;

        props.setStepAction(props.idStep, props.idRule, rule, props.stepNumber, props.ruleNumber);
    };

    let menuItems = props.orgChartRoles.map((rule) => {
        return {
            key: rule.orgChartRoleId,
            text: rule.name,
            onClick: () => selectOrgChartRole(rule),
            disabled: false,
            selected: props.action && props.action.orgChartRole === rule.orgChartRoleId
        };
    });

    return (
        <div className="dropdown-menu-scrollable">
            <DropdownSelect
                id="Org_Chart_Selection"
                type={DropdownSelectTypes.VALUE}
                value={displayValue}
                items={menuItems}
                isEmpty={menuItems.length === 0}
            />
        </div>
    )
};
const OrganisationChartStateToProps = function (store) {
    return {
        orgChartRoles: reduxSelectors.getOrganizationChart(store)
    };
};
export const OrganisationChartAction = connect(OrganisationChartStateToProps, {setStepAction})(OrganisationChart);

export const ProjectManager = (props) => {

    const useSkipIfNoProject = launchDarkly.companyClient && launchDarkly.companyClient.variation("skip-if-no-project", false);

    let selectSkipIfNoProject = function () {
        let rule = props.action ? _.clone(props.action) : RULE_TYPES[props.componentType];
        rule.skipIfNoProject = !props.action.skipIfNoProject;

        props.setStepAction(props.idStep, props.idRule, rule, props.stepNumber, props.ruleNumber);
    };

    return (
        <div className="mt-2 d-flex ">
            <span data-for={`step-manager-title-tooltip-${props.idStep}-${props.idRule || props.ruleNumber || props.stepNumber}`} data-tip="">
                <CircleQuestionMark size={ICON_SIZE.MEDIUM}/>
            </span>
            <Tooltip
                id={`step-manager-title-tooltip-${props.idStep}-${props.idRule || props.ruleNumber || props.stepNumber}`}
                content={() => props.translate("workflowDetails.managerTitle")}
            />
            {useSkipIfNoProject &&
                <div className="checkbox my-1 ms-5" onClick={selectSkipIfNoProject}>
                    <input type="checkbox"
                           aria-label={translate("myTasks.selectAllTasks")}
                           checked={props.action.skipIfNoProject}/>
                    <label className="checkbox-label">{props.translate("workflowDetails.skipIfNoProject")}</label>
                </div>
            }
        </div>
    )
};
export const ProjectManagerAction = connect(() => {
}, {setStepAction})(ProjectManager);


export const ProjectRole = (props) => {

    const useSkipIfNoProject = launchDarkly.companyClient && launchDarkly.companyClient.variation("skip-if-no-project", false);

    let selectProjectRole = function (value) {
        let rule = props.action ? _.clone(props.action) : RULE_TYPES[props.componentType];
        rule.role = value.roleId;

        props.setStepAction(props.idStep, props.idRule, rule, props.stepNumber, props.ruleNumber);
    };

    let findRole = props.action && props.action.role ? _.findIndex(props.configRoles, (role => {
        return role.roleId === props.action.role;
    })) : -1;

    let displayedRole = findRole !== -1 ? props.configRoles[findRole].name : props.translate("workflowDetails.selectRole");

    let menuItems = props.configRoles.map((role) => {
        return {
            key: role.roleId,
            text: role.name,
            onClick: () => selectProjectRole(role),
            disabled: false,
            selected: props.action && props.action.role === role.roleId
        };
    });

    let selectSkipIfNoProject = function () {
        let rule = props.action ? _.clone(props.action) : RULE_TYPES[props.componentType];
        rule.skipIfNoProject = !props.action.skipIfNoProject;

        props.setStepAction(props.idStep, props.idRule, rule, props.stepNumber, props.ruleNumber);
    };
    return (
        <div className="d-flex">
            <div className="dropdown-menu-scrollable">
                <DropdownSelect
                    id="Project_Role_Selection"
                    type={DropdownSelectTypes.VALUE}
                    value={displayedRole}
                    items={menuItems}
                    isEmpty={menuItems.length === 0}
                />
            </div>
            {useSkipIfNoProject &&
                <div className="checkbox ms-5" onClick={selectSkipIfNoProject}>
                    <input type="checkbox"
                           aria-label={translate("myTasks.selectAllTasks")}
                           checked={props.action.skipIfNoProject}/>
                    <label className="checkbox-label">{props.translate("workflowDetails.skipIfNoProject")}</label>
                </div>
            }
        </div>

    )
};
const ProjectRoleStateToProps = function (store) {
    return {
        configRoles: reduxSelectors.getConfigRoles(store)
    };
};
export const ProjectRoleAction = connect(ProjectRoleStateToProps, {setStepAction})(ProjectRole);


export class CostUnits extends Component {
    constructor(props) {
        super(props);

        this.selectCostUnit = this.selectCostUnit.bind(this);
    }

    selectCostUnit(value) {
        let rule = this.props.action ? _.clone(this.props.action) : RULE_TYPES[this.props.componentType];
        rule.role = value.roleId;

        this.props.setStepAction(this.props.idStep, this.props.idRule, rule, this.props.stepNumber, this.props.ruleNumber);
    };

    render() {
        let findRole = this.props.action ? _.findIndex(this.props.costUnits, (role => {
            return role.roleId === this.props.action.role;
        })) : -1;

        let displayValue = findRole !== -1 ? this.props.costUnits[findRole].name : "";

        let menuItems = this.props.costUnits.map((rule) => {
            return {
                key: rule.roleId,
                text: rule.name,
                onClick: () => this.selectCostUnit(rule),
                disabled: false,
                selected: this.props.action && this.props.action.role === rule.roleId
            };
        });

        return (
            <div className="dropdown-menu-scrollable">
                <DropdownSelect
                    id="Rule_Type_Selection"
                    type={DropdownSelectTypes.VALUE}
                    value={displayValue}
                    items={menuItems}
                    isEmpty={menuItems.length === 0}
                />
            </div>

        )
    }
}
const withTranslations = translate(CostUnits);
const CostUnitsStateToProps = function (store) {
    return {
        costUnits: reduxSelectors.getCostUnits(store)
    };
};
export const CostUnitsAction = connect(CostUnitsStateToProps, {setStepAction})(withTranslations);


export const DepartmentManagerAction = (props) => {
    return (
        <div className="mt-2">
            <span data-for={`step-department-title-tooltip-${props.idStep}-${props.idRule || props.ruleNumber || props.stepNumber}`} data-tip="">
                <CircleQuestionMark size={ICON_SIZE.MEDIUM}/>
            </span>
            <Tooltip
                id={`step-department-title-tooltip-${props.idStep}-${props.idRule || props.ruleNumber || props.stepNumber}`}
                content={() => props.translate("workflowDetails.departmentTitle")}
            />
        </div>
    )
};


export class ListOfApprovers extends Component {

    constructor(props) {
        super(props);
        this.state = {
            users: [],
            companyUserMap: this.props.companyUserMap,
            exceptions: null,
            showAuto: true,
            automaticApprove: this.props.action ? this.props.action.automaticApprovalUsers : false
        };
        this.changeUser = this.changeUser.bind(this);
        this.save = this.save.bind(this);
        this.changeExceptions = this.changeExceptions.bind(this);
        this.toggleAutomaticApproval = this.toggleAutomaticApproval.bind(this);
        this.mapData = this.mapData.bind(this);
        this.fetchAndSetUser = this.fetchAndSetUser.bind(this);
    }


    componentDidMount() {
        const nameNotFoundLabel = this.props.translate("users.nameNotFound");
        if (this.props.action)
            this.props.getAllUsers(this.props.idStep, this.props.action, nameNotFoundLabel);
        this.mapData();
    }

    mapData() {
        const nameNotFoundLabel = this.props.translate("users.nameNotFound");
        //map the users IDs
        if (this.props.action && this.props.action.users && this.state.companyUserMap) {
            const users = this.props.action.users.map(userId => {
                const user = this.state.companyUserMap[userId] || {
                    idUser: userId,
                    fullNameOrEmail: nameNotFoundLabel,
                    hasRoleInCompany: false,
                };

                return {
                    valid: Boolean(user.hasRoleInCompany),
                    label: user.fullNameOrEmail,
                    value: user.idUser
                }
            });
            this.setState({
                users: this.props.action.automaticApprovalUsers ? users[0] : users
            })
        }

        if (this.props.action && this.props.action.exceptions && this.state.companyUserMap) {
            //let allowAutomaticApproval = false;

            const exceptions = this.props.action.exceptions.map(exception => {
                const requesterId = exception.user;
                const requester = this.state.companyUserMap[requesterId] || {
                    idUser: requesterId,
                    fullNameOrEmail: nameNotFoundLabel,
                    hasRoleInCompany: false
                };
                const approverIds = exception.users;

                return {
                    valid: Boolean(requester.idUser),
                    label: requester.fullNameOrEmail,
                    value: requester.idUser,
                    users: approverIds.map((approverId) => {
                        const approver = this.state.companyUserMap[approverId] || {
                            idUser: approverId,
                            fullNameOrEmail: nameNotFoundLabel,
                            hasRoleInCompany: false
                        };

                        return {
                            valid: Boolean(approver.hasRoleInCompany),
                            label: approver.fullNameOrEmail,
                            value: approver.idUser
                        }
                    }),
                    automaticApproval: exception.automaticApproval
                };
            });
            this.setState({
                exceptions: exceptions,
                // showAuto: allowAutomaticApproval
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.action || !this.props.action || prevProps.action.users !== this.props.action.users || this.props.action.exceptions !== prevProps.action.exceptions) {
            this.mapData();
        }
    }

    async fetchAndSetUser(rule, userId) {
        if (!this.state.companyUserMap[userId]) {
            const userFromApi = await Api.getCompanyUser(userId);
            this.setState({
                companyUserMap: {
                    ...this.state.companyUserMap,
                    [userId]: {
                        ...userFromApi,
                        hasRoleInCompany: userFromApi.hasRoleInCompany !== undefined ? userFromApi.hasRoleInCompany : true
                    }
                }
            });
        }
    }

    async changeUser(value) {
        this.setState({
            users: value
        });
        let rule = this.props.action ? _.clone(this.props.action) : RULE_TYPES[this.props.componentType];

        if (this.state.automaticApprove) {
            rule.users = [value.value];
        } else {
            rule.users = value && Array.isArray(value) ? value.map(user => {
                return user.value
            }) : [];
        }

        for (const userId of rule.users) {
            await this.fetchAndSetUser(rule, userId);
        }

        this.props.setStepAction(this.props.idStep, this.props.idRule, rule, this.props.stepNumber, this.props.ruleNumber);
    }

    async save(exceptions) {
        let rule = this.props.action ? _.clone(this.props.action) : RULE_TYPES[this.props.componentType];
        rule.exceptions = exceptions;

        for (const exception of exceptions) {
            const requesterId = exception.user;
            const approverIds = exception.users;

            await this.fetchAndSetUser(rule, requesterId);

            for (const approverId of approverIds) {
                await this.fetchAndSetUser(rule, approverId);
            }
        }

        this.props.setStepAction(this.props.idStep, this.props.idRule, rule, this.props.stepNumber, this.props.ruleNumber);
    }

    changeExceptions(values) {
        this.setState({
            exceptions: values
        });

        this.props.setStepExceptions(this.props.idStep, values);
    }

    toggleAutomaticApproval(event) {
        this.setState({automaticApprove: event.target.checked});

        let currentUsers = _.clone(this.state.users);
        let rule = this.props.action ? _.clone(this.props.action) : {};

        if (event.target.checked) {
            if (currentUsers.length > 0) {
                currentUsers = {
                    valid: currentUsers[0].valid,
                    label: currentUsers[0].label,
                    value: currentUsers[0].value
                };
            }
            rule.users = [currentUsers.value];
        } else {
            currentUsers = [{valid: currentUsers.valid, label: currentUsers.label, value: currentUsers.value}];
            rule.users = currentUsers.map(user => {
                return user.value
            });

        }
        this.setState({
            users: currentUsers
        });
        rule.automaticApprovalUsers = event.target.checked;
        let isComplete = currentUsers.length > 0;
        this.props.setStepAction(this.props.idStep, this.props.idRule, rule, this.props.stepNumber, this.props.ruleNumber, isComplete);

    }


    render() {

        let users = (this.props.action && !this.props.action.automaticApprovalUsers && this.state.users.length > 0) ? this.state.users.map(user => {
            return {valid: user.valid, label: user.label, value: user.value};
        }) : this.state.users;

        //non-HRM documents don't have exceptions
        let showExceptions = this.props.type !== DOCUMENT_TYPE.INVOICE && this.props.type !== DOCUMENT_TYPE.VOUCHER && this.props.type !== DOCUMENT_TYPE.SUPPLIER;
        let showAutomaticApproval = this.props.type === DOCUMENT_TYPE.EXPENSE_CLAIM || this.props.type === DOCUMENT_TYPE.LEAVE_REQUEST || this.props.type === DOCUMENT_TYPE.TIMESHEET;

        return (
            <div className={"approve-with-exceptions" + (showAutomaticApproval ? " mt-2" : "")}>
                {showAutomaticApproval &&
                    <div className="checkbox">
                        <input type="checkbox"
                               className="automatic-checkbox"
                               id={`amount-condition-checkbox${this.props.idStep}`}
                               checked={this.state.automaticApprove}
                               onChange={this.toggleAutomaticApproval}/>
                        <label htmlFor={`amount-condition-checkbox${this.props.idStep}`}>
                            {this.props.translate("workflowDetails.automaticApproval")}
                        </label>
                    </div>
                }
                <UserSearch propagateValue={this.changeUser}
                            multi={!this.state.automaticApprove}
                            includeSameUser={true}
                            companyId={this.props.companyId}
                            stopFocus={true}
                            value={users}
                            translate={this.props.translate}
                            menuPosition={"fixed"}
                            menuPortalTarget={document.body}

                />
                {showExceptions &&
                    <div className="no-side-padding step-exceptions-area">
                        <div className="mt-4">
                            {this.props.translate("workflowDetails.exceptions.exceptEmployees")}
                        </div>
                        <div>
                            <Exceptions data={this.state.exceptions}
                                        stepId={this.props.idStep}
                                        noDuplicates={true}
                                        showAuto={this.state.showAuto}
                                        changeExceptions={this.changeExceptions}
                                        saveExceptions={this.save}
                                        allowActions={showExceptions}/>

                        </div>
                    </div>
                }

            </div>
        )
    }
}

const
    listOfApproverswithTranslations = translate(ListOfApprovers);
const
    ListOfApproversToProps = function (store) {
        return {
            costUnits: reduxSelectors.getCostUnits(store),
            usersList: reduxSelectors.getExceptionUsers(store),
            companyId: reduxSelectors.getUsersCurrentContextId(store)
        };
    };
export const
    ListOfApproversAction = connect(ListOfApproversToProps, {
        setStepAction,
        getAllUsers,
        setStepExceptions
    })(listOfApproverswithTranslations);